const brandRouter = [
  {
    path: '/brandHome',
    name: 'brandHome',
    redirect: '/ChinaEnterprise',
    component: () => import('@/views/brand/homeNew/homeNew'),
    children: [
      {
        path: '/ChinaEnterprise',
        name: "ChinaEnterprise",
        component: () => import('@/views/brand/homePage/homePage'),
      },
      {
        path: '/search',
        name: "search",
        component: () => import('@/views/brand/search/search'),
      },
      {
        path: '/articleDetail',
        name: 'articleDetail',
        component: () => import('@/views/brand/searchDetail/articleDetail.vue'),
      },
      {
        path: '/companyDetail',
        name: 'companyDetail',
        component: () => import('@/views/brand/searchDetail/companyDetail.vue'),
      }
    ],
  }
]
export default brandRouter
